import { ValidationErrors, ValidatorFn, AbstractControl } from "@angular/forms";

export function forbiddenSubstringValidator(
  substring: string,
  error: ValidationErrors
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (!control.value) {
      // if control is empty return no error
      return null;
    }

    // test the value of the control against the regexp supplied
    const valueString = String(control.value).toLowerCase();
    const valid = !valueString.includes(substring.toLowerCase())

    // if true, return no error (no error), else return error passed in the second parameter
    return valid ? null : error;
  };
}



// WEBPACK FOOTER //
// ./src/app/validators/forbidden-substring-validator.directive.ts